exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-list-item .content[data-v-4d296c76] {\n  display: grid;\n  grid-template-columns: 3fr 1fr 1fr;\n  grid-gap: 16px;\n  font-family: 'Roboto Mono', monospace;\n  font-size: 12px;\n}\n.module-list-item .info[data-v-4d296c76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.module-list-item .size[data-v-4d296c76] {\n  color: #42b983;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.module-list-item .vue-ui-loading-bar[data-v-4d296c76] {\n  width: 100%;\n}\n", ""]);

// exports
